// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS } from "../../constants/variables";

export const Circle = styled.span<{ $active: boolean }>`
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $active }) =>
    $active ? COLORS.VividAuburn : COLORS.MetalicSilver};
`;

export const SliderWrapper = styled.section`
  padding: 40px 0 24px;
  width: calc(100% - 48px);
  max-width: 1464px;
  min-width: 0;
  position: relative;
  @media (max-width: 767px) { padding-top: 32px; }
`;
export const CenterWrapper = styled.div`
  width: 100%;
  min-width: 0;
  .slick-list { margin: 0 -12px; }
  .slick-slide > div { padding: 4px 12px; }
  .slick-dots {
    position: static;
    display: flex !important;
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px;
    margin: 16px 0 0;
    padding: 0;
  }
  .slick-dots li { width: 24px; height: 24px; margin: 0; }
  .slick-dots li button {
    display: grid;
    place-items: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    background: transparent;
    border-radius: 50%;
  }
  .slick-dots li button::before { display: none; }
  .slick-dots li button:focus-visible { outline: 2px solid ${COLORS.Crimson}; outline-offset: 2px; }
  @media (prefers-reduced-motion: reduce) {
    .slick-track { transition-duration: 0s !important; }
  }
`;
